import React from 'react'
import Pagination from '../Pagination/pagination';
import moment from 'moment'
import Spinner from '../Spinner/spinner';
import { ToastContainer } from 'react-toastify';
import UseAppointment from './Hooks/useAppointment';
const Appointment = () => {

    const { method, data } = UseAppointment()
    const {
        appointmentLists,
        setPage,
        navigate,
        handleChange, } = method

    const {
        clientList,
        teamList,
        filter,
        page,
        count,
        spinner,
        PER_PAGE,
        appointmentFilterData,
    } = data

    return (
        <>
            <ToastContainer />
            <section>
                <div className="m-t-3 cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Appointment List
                        </h2>
                        <hr />
                        <p className='mt-4 d-flex'>Total Appointments : {appointmentFilterData.totalCount}</p>
                        <div className='row'>
                            <div className='mt-4 col-sm-3'>
                                <input type="text" className='form-control' placeholder='Search by appointment' name='appointmentsNO' value={filter.appointmentsNO} onChange={(e) => handleChange(e)} autoComplete='off' />
                            </div>
                            <div className='col-sm-3'>
                                <label className="form-label"></label>
                                <select className='form-select' name='client' onChange={(e) => handleChange(e)} value={filter.client}>
                                    <option value="" hidden>Client</option>
                                    {
                                        clientList?.map((item) =>
                                            <option value={item._id}>{item.name}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className='col-sm-3'>
                                <label className="form-label"></label>
                                <select className='form-select' name='staff' onChange={(e) => handleChange(e)} value={filter.staff}>
                                    <option value="" hidden>Team</option>
                                    {
                                        teamList?.map((item) =>
                                            <option value={item._id}>{item.name}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className='col-sm-3'>
                                <label className="form-label"></label>
                                <select className='form-select' name='status' onChange={(e) => handleChange(e)} value={filter.status}>
                                    <option value="" hidden>Status</option>
                                    <option value="ACCEPTED">Accepted</option>
                                    <option value="CANCELLED">Cancelled</option>
                                    <option value="Pending">Pending</option>
                                    <option value="DECLINED">Declined</option>
                                </select>
                            </div>
                            <div className='mt-4  d-flex col-sm-3'>
                                <h6 className='mt-2'>Start</h6>
                                <h6 className='ms-1 mt-2'>Date</h6>
                                <input className='form-control ms-1' type="date" name="statDate" onChange={(e) => handleChange(e)} value={filter.statDate} style={{ height: '37px' }} />

                            </div>
                            <div className='mt-4 d-flex col-sm-3'>
                                <h6 className='mt-2'>End</h6>
                                <h6 className='ms-1 mt-2'>Date</h6>
                                <input className='form-control ms-1' type="date" name="endDate" onChange={(e) => handleChange(e)} value={filter.endDate} style={{ height: '37px' }} />
                            </div>

                            <div className="col-sm-4"></div>
                            <div className="col-sm-2 d-flex justify-content-end">
                                <button type="submit" onClick={() => appointmentLists()} className="btn btn-primary  px-3 my-4 m-2">Search</button>
                                <button type="button" className="btn btn-dark  px-4 my-4" onClick={() => window.location.reload()}>Reset</button>

                            </div>
                        </div>
                    </header>

                    <table className="table  shadow mt-3">
                        <thead className="table-dark">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Appointment Number</th>
                                <th scope="col">Date</th>
                                <th scope="col">Time</th>
                                <th scope="col">Client</th>
                                <th scope="col">Team</th>
                                <th scope="col">Status</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                appointmentFilterData.totalCount === undefined ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                                    :
                                    <>
                                        {
                                            appointmentFilterData.data?.map((item, index) => {
                                                return <>
                                                    <tr key={index}>
                                                        <th scope="row">{PER_PAGE * (page - 1) + index + 1}</th>
                                                        <td>{item.appointment_number}</td>
                                                        <td>{moment(item.startDateTime).format('DD-MM-YYYY')}</td>
                                                        <td>{moment(item.startDateTime).format('LT')} - {moment(item.endDateTime).format('LT')}</td>
                                                        <td>{item.clientName}</td>
                                                        <td>{item.staffName}</td>
                                                        <td>{item.status}</td>
                                                        <td>
                                                            <svg onClick={() => navigate(`appointmentView/${item._id}/${item.createdby_id}`)} style={{ cursor: "pointer", fill: '#146EBE' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#315e99" className="bi bi-eye-fill" viewBox="0 0 16 16"><path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" /><path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" /></svg>

                                                        </td>
                                                    </tr>
                                                </>
                                            })
                                        }
                                    </>
                            }
                        </tbody>
                    </table>
                    <div className='w-100 d-flex justify-content-center pb-2'>
                        {appointmentFilterData.length < 10 ? null :
                            count > 10 && <Pagination setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Appointment;